import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
@Injectable()
export class EqualPasswordsValidator {
  public static validate(firstField: string, secondField: string) {
    return (c: FormGroup) => {
      return c.controls &&
        c.controls[firstField].value == c.controls[secondField].value
        ? null
        : {
            passwordsEqual: {
              valid: false,
            },
          };
    };
  }
}
